import React, { useState, useEffect } from 'react';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import PublicModalWrappers from '../components/public/PublicModalWrappers';
import ActiaveAudience from '../components/AudienceBuilder/ActivateAudience';
import AudiencePreview from '../components/AudienceBuilder/AudiencePreview';
import AudienceCriteria from '../components/AudienceBuilder/AudienceCriteria';
import AudiencePeopleChart from '../components/AudienceBuilder/AudiencePeopleChart';
import LoadingContainer from '../components/LoadingContainer';
import SVGIcon from '../components/SVGIcon';
import { fetchBoundaries } from '../store/actions/location-actions';

import {
  fetchAudiencePreview,
  fetchIntegrations,
} from '../store/actions/audienceBuilder-actions';
import { setLastAudienceBuilderPage } from '../store/actions/route-actions';



const AudienceBuilder = () => {
  const dispatch = useDispatch();
  const client = useSelector(state => state.client);

  const audiencePreviewData = useSelector(
    state => state.audienceBuilder.audiencePreviewData
  );
  const audiencePreviewDataLoaded = useSelector(
    state => state.audienceBuilder.audiencePreviewDataLoaded
  );
  const integrations = useSelector(state => state.audienceBuilder.integrations);
  const integrationsLoaded = useSelector(
    state => state.audienceBuilder.integrationsLoaded
  );
  // modal open
  const [modalOpen, toggleModal] = useState(false);
  const closeModal = () => {
    toggleModal(false);
  };

  const loadData = () => {
    dispatch(fetchAudiencePreview(client.id));
  };

  useEffect(() => {
    loadData();
    dispatch(fetchBoundaries());
    dispatch(fetchIntegrations(client.id));
    dispatch(setLastAudienceBuilderPage('/audience-builder'));
  }, []);

  return (
    <div>
      <Header />

      <main>
        <div
          className="Account_top"
          style={{ backgroundColor: '#fff', padding: 0 }}
        >
          <div style={{ width: '100%' }}>
            <div style={{ backgroundColor: '#f3f3f3', padding: '1rem 2rem' }}>
              <div >
                <h1 style={{ display: 'inline-block' }}>Audience Builder</h1>

              </div>
            </div>
            <div className={`Audience_Loading-container${audiencePreviewDataLoaded ? `` : `-loading`}`}>
              <button
                className="Audience_backButton"
                onClick={() => window.history.back()}
              >
                <SVGIcon icon="back-arrow" />
                Back
              </button>
            <LoadingContainer loading={!audiencePreviewDataLoaded}>

              <AudiencePeopleChart audiencePreviewData={audiencePreviewData} />
              <AudiencePreview
                clientName={client.name}
                audiencePreviewData={audiencePreviewData}
              />

            </LoadingContainer>
            </div>

            <AudienceCriteria
            loadData={loadData}
            clientId={client.id}
            toggleModal={toggleModal}
            />
          </div>
        </div>
      </main>

      <PublicModalWrappers
        isOpen={modalOpen}
        close={() => closeModal(!modalOpen)}
      >
        <div className="Account_section-title-row">
          <h2 className="Account_section-title-row_title">Activate Audience</h2>
        </div>

        <ActiaveAudience
          integrations={integrations}
          integrationsLoaded={integrationsLoaded}
        />
      </PublicModalWrappers>

    </div>
  );
};

export default AudienceBuilder;
